import React, {Component} from "react";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

const RATING_OPTIONS = [1, 2, 3, 4, 5].map(r => ({value: r, label: String(r)}));

class ServiceRatingFilter extends Component {
    state = {
        ratingValue: null
    };

    resetRatingFilter(){
        this.setState({
            ratingValue: [],
        })
    }

    changeRating(optionSelected){
        let ratingArray = '';
        if(optionSelected && optionSelected.length > 0){
            ratingArray = optionSelected.map(item => item.value);
        }
        this.props.onSelectRating(optionSelected, ratingArray);
        this.setState({
            ratingValue: optionSelected,
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes name="rating"
            isMulti
            value={this.state.ratingValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeRating.bind(this)}
            options={RATING_OPTIONS}
            placeholderButtonLabel="Select [Rating]"
        />
        );
    }
}
export default ServiceRatingFilter;
